<template>
  <svg
    class="indicator"
    style="z-index: 2"
    xmlns:svg="http://www.w3.org/2000/svg"
    xmlns="http://www.w3.org/2000/svg"
    version="1.1"
    width="100%"
    height="100%"
    viewBox="0 0 48 20"
    preserveAspectRatio="none"
  >
    <title>{{ hint }}</title>
    <g>
      <rect
        id="main"
        x="0"
        y="0"
        width="100%"
        height="100%"
        :fill="fill"
        stroke="gray"
        stroke-width="1"
      ></rect>

      <text
        id="heading_caption"
        x="95%"
        y="70%"
        :class="{ 'f-indicator': true, unselectable: $store.getters.editMode }"
        :text-anchor="text_anchor"
        :font-weight="fontStyle"
        lengthAdjust="spacingAndGlyphs"
      >
        {{ level_value }}
      </text>
    </g>
  </svg>
</template>

<script>
import MixinStates from "./mixin-states.js";

export default {
  name: "indicator",
  mixins: [MixinStates],
  props: {
    text_anchor: {
      type: String,
      default: "end",
    },
    fill: {
      type: String,
      default: "#f8f9fa",
    },
  },
  computed: {
    value: function () {
      if (typeof this.properties[this.PropertyURI] == "undefined") {
        return null;
      } else {
        return this.properties[this.PropertyURI].outputValue.value;
      }
    },
    level_value: function () {
      return this.round && this.value !== null && this.value !== undefined
        ? this.value.toFixed(this.round)
        : this.value;
    },
  },
};
</script>

<style scoped>
.f-indicator {
  font-family: var(--font-family);
}
</style>
